import { withWidth } from '@material-ui/core';
import { Container, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
    textAlign: 'center',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
  glow: {
    textShadow: '0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12',
  },
}));

const Copy1B = ({ width, ...props }) => {
  const classes = useStyles();

  const [marginsA, setmarginsA] = useState(0);
  
  useEffect(() => {
    const Copy1BaElement = document.getElementById('Copy1BA');
    const calculatedMarginA = (window.innerHeight - Copy1BaElement.clientHeight) / 2;
    setmarginsA(
      calculatedMarginA > window.innerHeight / 4 ? calculatedMarginA : window.innerHeight / 4,
    );
  }, []);

  return (
    <Container>
      <div id="Copy1BA" style={{ margin: `${marginsA}px auto` }}>
        <Typography
          className={classes.textMonarcha}
          sx={{ color: '#ffbf12', marginBottom: 8 ,fontSize: width === 'xs' ? '1.65rem' : '' }}
          variant="h3"
        >
          <span style={{ color: '#fff' }}> Build a</span> <br />
          $1 billion personal brand startup <br />
          <span style={{ color: '#fff' }}> With PassionStocks</span>
        </Typography>
        <Typography className={classes.textMonarcha} sx={{ color: '#ffbf12',fontSize: width === 'xs' ? '1.65rem' : ''  }} variant="h3">
          <span style={{ color: '#fff' }}> —no </span>
          <br />
          capital, company registration, <br />
          or trademark <br />
          <span style={{ color: '#fff' }}> required to get{width === 'xs' && <br />} started.</span>
        </Typography>
      </div>
    </Container>
  );
};
export default withWidth()(Copy1B);
